import React, { useEffect } from 'react';
import cx from 'classnames';

import CurrencySwitcher from 'app/components/ui/CurrencySwitcher';
import InputSearch from 'app/components/common/InputSearch';
import Breadcrumbs from 'app/components/common/Breadcrumbs';
import { useBreadcrumbs } from 'app/context/BreadcrumbsContext';

import s from './Header.module.sass';
import HeaderMobile from './HeaderMobile';

type HeaderProps = {
  className?: string
};

const Header: React.FC<HeaderProps> = ({
  className,
}) => {
  const { breadcrumbs, setBreadcrumbs } = useBreadcrumbs();

  useEffect(() => {
    setBreadcrumbs(null);
  }, [setBreadcrumbs]);

  return (
    <header className={cx(s.root, { [s.paddingBottom]: !breadcrumbs }, className)}>
      <div className={cx(s.desktop)}>
        <div className={cx(s.wrapper)}>
          <InputSearch />

          <CurrencySwitcher className={cx(s.switcher)} />
        </div>

        {breadcrumbs && <Breadcrumbs data={breadcrumbs} />}
      </div>

      <HeaderMobile />
    </header>
  );
};

export default Header;
